import React, { useEffect, useState, useCallback } from 'react';
import axios from 'axios';
import { API } from '../config';
import { tr } from '../til';


const CATEGORIES = {
  taklif: { label: tr("Taklif"), color: '#2d8a2d', bg: '#e9f9ed' },
  shikoyat: { label: tr("Shikoyat"), color: '#c93636', bg: '#ffeaea' },
  savol: { label: tr("Savol"), color: '#4f8ef7', bg: '#e6f0ff' },
  boshqa: { label: tr("Boshqa"), color: '#888', bg: '#f2f2f2' }
};

const smallBtn = {
  padding: '6px 12px',
  background: '#eef1f7',
  color: '#1a1a2e',
  border: '1px solid #ddd',
  borderRadius: '8px',
  fontSize: '12px',
  cursor: 'pointer'
};

const formatDateTime = (raw) => {
  const d = new Date(raw);
  if (isNaN(d)) return '';
  return `${d.toLocaleDateString('uz-UZ')} ${d.getHours().toString().padStart(2, '0')}:${d.getMinutes().toString().padStart(2, '0')}`;
};

function Messages() {
  const [messages, setMessages] = useState([]);
  const [filter, setFilter] = useState('all');
  const [error, setError] = useState('');

  const token = localStorage.getItem('token');

  const load = useCallback(() => {
    axios.get(`${API}/messages`, { headers: { authorization: token } })
      .then(res => setMessages(res.data))
      .catch(() => setError(tr("Murojaatlarni yuklab bo'lmadi")));
  }, [token]);

  useEffect(() => {
    load();
  }, [load]);

  const toggleRead = async (m) => {
    setError('');
    try {
      await axios.put(`${API}/messages/${m.id}/read`, { is_read: !m.is_read }, {
        headers: { authorization: token }
      });
      load();
    } catch {
      setError(tr("Amal bajarilmadi"));
    }
  };

  const remove = async (m) => {
    setError('');
    if (!window.confirm(tr("Bu murojaat o'chirilsinmi?\n\nQaytarib bo'lmaydi."))) return;
    try {
      await axios.delete(`${API}/messages/${m.id}`, { headers: { authorization: token } });
      load();
    } catch {
      setError(tr("O'chirib bo'lmadi"));
    }
  };

  const unreadCount = messages.filter(m => !m.is_read).length;

  const visible = messages.filter(m => {
    if (filter === 'all') return true;
    if (filter === 'unread') return !m.is_read;
    return m.category === filter;
  });

  const tabStyle = (active) => ({
    padding: '7px 16px',
    border: '1px solid #ddd',
    borderRadius: '8px',
    background: active ? '#1a1a2e' : '#fff',
    color: active ? '#fff' : '#666',
    fontSize: '13px',
    cursor: 'pointer'
  });

  return (
    <div>
      <h2 style={{ marginBottom: '8px', fontSize: '22px' }}>
        {tr("Anonim murojaatlar")}
        {unreadCount > 0 && (
          <span style={{
            marginLeft: '10px',
            background: '#c93636',
            color: '#fff',
            padding: '2px 10px',
            borderRadius: '20px',
            fontSize: '13px',
            verticalAlign: 'middle'
          }}>
            {tr("{unreadCount} yangi", { unreadCount })}
          </span>
        )}
      </h2>
      <p style={{ marginTop: 0, marginBottom: '20px', color: '#888', fontSize: '13px' }}>
        🔒 {tr("Murojaatlar to'liq anonim — kim yozgani saqlanmaydi va aniqlab bo'lmaydi.")}
      </p>

      <div style={{ display: 'flex', gap: '8px', marginBottom: '20px', flexWrap: 'wrap' }}>
        <button onClick={() => setFilter('all')} style={tabStyle(filter === 'all')}>
          {tr("Hammasi ({soni})", { soni: messages.length })}
        </button>
        <button onClick={() => setFilter('unread')} style={tabStyle(filter === 'unread')}>
          {tr("O'qilmagan ({unreadCount})", { unreadCount })}
        </button>
        {Object.entries(CATEGORIES).map(([key, c]) => {
          const count = messages.filter(m => m.category === key).length;
          return (
            <button key={key} onClick={() => setFilter(key)} style={tabStyle(filter === key)}>
              {c.label} ({count})
            </button>
          );
        })}
      </div>

      {error && (
        <div style={{ background: '#ffeaea', color: '#c93636', padding: '10px 12px', borderRadius: '8px', fontSize: '13px', marginBottom: '16px' }}>
          {error}
        </div>
      )}

      {visible.length === 0 && (
        <div style={{ background: '#fff', borderRadius: '12px', padding: '40px 24px', textAlign: 'center', boxShadow: '0 1px 8px rgba(0,0,0,0.06)' }}>
          <p style={{ color: '#999', fontSize: '14px', margin: 0 }}>
            {messages.length === 0 ? tr("Hali murojaat kelmagan.") : tr("Bu bo'limda murojaat yo'q.")}
          </p>
        </div>
      )}

      {visible.map(m => {
        const cat = CATEGORIES[m.category] || CATEGORIES.boshqa;
        return (
          <div
            key={m.id}
            style={{
              background: '#fff',
              borderRadius: '12px',
              padding: '20px',
              marginBottom: '14px',
              boxShadow: '0 1px 8px rgba(0,0,0,0.06)',
              borderLeft: m.is_read ? '4px solid #f0f0f0' : `4px solid ${cat.color}`
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '12px', flexWrap: 'wrap' }}>
              <span style={{
                background: cat.bg,
                color: cat.color,
                padding: '3px 12px',
                borderRadius: '20px',
                fontSize: '12px',
                fontWeight: '500'
              }}>
                {cat.label}
              </span>
              {!m.is_read && (
                <span style={{
                  background: '#c93636',
                  color: '#fff',
                  padding: '2px 8px',
                  borderRadius: '20px',
                  fontSize: '11px'
                }}>
                  {tr("yangi")}
                </span>
              )}
              <span style={{ color: '#aaa', fontSize: '12px' }}>
                {formatDateTime(m.created_at)}
              </span>

              <div style={{ marginLeft: 'auto', display: 'flex', gap: '6px' }}>
                <button onClick={() => toggleRead(m)} style={smallBtn}>
                  {m.is_read ? tr("O'qilmagan deb belgilash") : tr("O'qildi")}
                </button>
                <button onClick={() => remove(m)} style={{ ...smallBtn, color: '#c93636' }}>
                  {tr("O'chirish")}
                </button>
              </div>
            </div>

            <p style={{
              margin: 0,
              fontSize: '14px',
              lineHeight: '1.7',
              color: m.is_read ? '#666' : '#222',
              whiteSpace: 'pre-wrap'
            }}>
              {m.message}
            </p>
          </div>
        );
      })}
    </div>
  );
}

export default Messages;
